<template>
    <div class="mb-4">
        <!-- Product header -->
        <div class="flex--body">
            <div class="col-12 pt-3 pb-3 flex--body--header d-flex align-items-center" :class="{'flex--ticket--header--disabled': disabled}">
                <h3 class="pl-2 flex--body--title">
                    {{ ticket.ax_name }}
                    <small>{{ ticket.additional_description }}</small>
                </h3>
            </div>
        </div>

        <vue-slide-up-down :active="!showMoreButton || ticket.show" :duration="1000" v-if="ticket.products.length">
            <!-- Product body -->
            <div v-for="item in ticket.products" :key="item.id">
                <div class="flex--body flex--body--item" :class="{'flex--ticket--disabled': disabled}">
                    <product :data="item" :increase="increase" :decrease="decrease" :icon-color="btnColor"/>
                </div>
            </div>
        </vue-slide-up-down>

        <div class="flex--body flex--body--item" :class="{'flex--ticket--disabled': disabled}" v-else>
            <h5 class="text-center pt-4 pb-4 flex--no--tickets">Este ticket no tiene productos</h5>
        </div>

        <!-- Show more -->
        <div class="flex--footer--show--more" v-if="showMoreButton && ticket.products.length">
            <div class="col-12 pb-2 pt-3 text-center">
                <a class="flex--footer--show--more--button" v-show="!ticket.show" @click="toggle()">
                    Ver más
                    <span class="d-block">
                            <icon-base :view-box-height="512"
                                       :view-box-width="448"
                                       :width="25"
                                       :height="25"
                                       :icon-color="'#5ba3dc'">
                            <chevron-down-icon/>
                        </icon-base>
                    </span>
                </a>

                <a class="flex--footer--show--more--button" v-show="ticket.show" @click="toggle()">
                    Ver menos
                    <span class="d-block">
                            <icon-base :view-box-height="512"
                                       :view-box-width="448"
                                       :width="25"
                                       :height="25"
                                       :icon-color="'#5ba3dc'">
                            <chevron-up-icon/>
                        </icon-base>
                    </span>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
    import VueSlideUpDown from 'vue-slide-up-down';
    import cartMixin from '../mixins/cartMixin';
    import * as Actions from '../store/action-types';

    export default {
        props: {
            /**
             * Flex ticket information
             */
            data: {
                type: Object,
                required: true
            },

            show: {
                type: Boolean,
                default() {
                    return false;
                }
            },

            showMoreButton: {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },

        mixins: [cartMixin],

        components: {
            VueSlideUpDown
        },

        data() {
            return {
                ticket: {...this.data, show: this.show}
            }
        },

        computed: {
            disabled() {
                const currentTicket = this.$store.getters.currentTicket;

                return currentTicket && currentTicket.id
                    ? !(currentTicket.id === this.ticket.id)
                    : false;
            },

            btnColor() {
                return this.disabled ? "#bbc0c6" : "#59595c";
            }
        },

        methods: {
            toggle() {
                this.ticket.show = !this.ticket.show;
            },

            price(item, useRackPrice) {
                return useRackPrice ? item.rack_price : item.unit_price;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FlexTicket.vue